'use strict';

export default angular
  .module('maestro.filters.getAttributeValue', [])

  .filter('getAttributeValue', function($filter) {
    return function(arr, attributeName, nameVal, returnName, comparator) {
      if (!arr || arr.length == 0) {
        return '';
      }
      let p = {};
      p[attributeName] = nameVal;
      let item = $filter('getItem')(arr, p, comparator);
      return item[returnName];
    };
  })

  .name;
